import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ShieldCheck, ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const { loginAdmin } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await loginAdmin(email.trim(), password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Admin signed in");
      navigate("/admin", { replace: true });
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 bg-grid p-6">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-lg p-8 shadow-sm">
        <div className="flex items-center gap-2 text-slate-900">
          <ShieldCheck className="h-5 w-5" />
          <span className="font-display text-lg font-bold">Admin console</span>
        </div>
        <h2 className="font-display text-3xl font-extrabold mt-6 text-slate-900">
          Sign in to manage customers
        </h2>
        <p className="text-slate-600 mt-2 text-sm">
          Restricted area. Use your administrator credentials.
        </p>

        <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="admin-login-form">
          <div className="space-y-2">
            <Label htmlFor="email" className="label-overline text-slate-700">
              Email
            </Label>
            <Input
              id="email"
              data-testid="admin-email-input"
              type="email"
              placeholder="admin@balance.app"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="h-12 text-base"
              required
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password" className="label-overline text-slate-700">
              Password
            </Label>
            <Input
              id="password"
              data-testid="admin-password-input"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="h-12 text-base"
              required
            />
          </div>
          <Button
            type="submit"
            data-testid="admin-login-submit"
            disabled={submitting}
            className="w-full h-12 bg-slate-900 hover:bg-slate-800 text-white font-medium rounded-md gap-2"
          >
            {submitting ? "Signing in…" : "Enter console"}
            {!submitting && <ArrowRight className="h-4 w-4" />}
          </Button>
        </form>
      </div>
    </div>
  );
}
